import { Fragment, lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import './App.css';
import Fallback from './components/Fallback/Fallback';
import { ToastContainer } from 'react-toastify';
import SignIn from './pages/SignIn/SignIn.jsx';
import PFMDashboard from './pages/Dashboard/PFMDashboard/PFMDashboard';
// import jwtDecode from 'jwt-decode';
import CreateUser from './pages/User Management/Users/Create User/CreateUser';
import ListUsers from './pages/User Management/Users/List Users/ListUsers';
import ApproveUsers from './pages/User Management/Users/Approve Users/ApproveUsers';
import CreateUserRole from './pages/User Management/User Roles/Create User Role/CreateUserRole';
import ListUserRoles from './pages/User Management/User Roles/List User Roles/ListUserRoles';
import ApproveUserRoles from './pages/User Management/User Roles/Approve User Roles/ApproveUserRoles';
import ApproveTemplate from './pages/Consent Templates/Approve/ApproveTemplate';
import ListTemplates from './pages/Consent Templates/List/ListTemplates';
import CreateTemplates from './pages/Consent Templates/Create/CreateTemplates';

const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard.jsx'));
const CreateConsentRequest = lazy(() =>
	import('./pages/Consent Request/Create/CreateConsentRequest.jsx')
);
const TrackConsentRequest = lazy(() =>
	import('./pages/Consent Request/Track/TrackConsentRequest.jsx')
);
const ViewConsent = lazy(() =>
	import('./pages/Consent Request/View/ViewConsent.jsx')
);
const Insights = lazy(() => import('./pages/Account Insights/Insights.jsx'));
const ClassifierPage = lazy(() => import('./pages/Classifier/ClassifierPage'));

function App() {
	const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
	const isPFM = useSelector((state) => state.auth.isPFM);
	// const role = jwtDecode(
	// 	JSON.parse(sessionStorage.getItem('login'))?.token
	// )?.roles;

	// console.log(role);

	return (
		<Fragment>
			{isLoggedIn ? (
				<div className="App">
					<Header />
					<div className="app-body">
						<Sidebar />
						<Suspense fallback={<Fallback />}>
							<Routes>
								<Route path="/" element={isPFM ? <PFMDashboard /> : <Dashboard />} />
								<Route path="/create-consent-request" element={<CreateConsentRequest />} />
								<Route path="/track-consent-request" element={<TrackConsentRequest />} />
								<Route path="/view-consent" element={<ViewConsent />} />
								<Route path="/account-insights" element={<Insights />} />
								<Route path="/approve-template" element={<ApproveTemplate />} />
								<Route path="/list-template" element={<ListTemplates />} />
								<Route path="/create-template" element={<CreateTemplates />} />
								<Route path="/create-user" element={<CreateUser />} />
								<Route path="/list-user" element={<ListUsers />} />
								<Route path="/approve-user" element={<ApproveUsers />} />
								<Route path="/create-user-role" element={<CreateUserRole />} />
								<Route path="/list-user-role" element={<ListUserRoles />} />
								<Route path="/approve-user-role" element={<ApproveUserRoles />} />
								<Route path="/classifier" element={<ClassifierPage />} />
							</Routes>
						</Suspense>
					</div>
				</div>
			) : (
				<Routes>
					<Route path="/" element={<SignIn />} />
				</Routes>
			)}
			<div>
				<ToastContainer
					position="top-right"
					autoClose={3000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="light"
				/>
			</div>
		</Fragment>
	);
}

export default App;
